import React, { useEffect, useState } from "react";

const CustomizedToast = ({ options }) => {
  const { message, type, onClose, duration, iconSrc = "" } = options;
  const [fade, setFade] = useState(false);

  useEffect(() => {
    setFade(true);
    const timeoutId = setTimeout(() => {
      setFade(false);
      setTimeout(onClose, 500); // Wait for the fade-out animation to finish before removing
    }, duration);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [onClose, duration]);

  return (
      <div
          className={`toast-container ${options?.wrapperClass || ""}`}
          aria-live="polite"
          aria-atomic="true"
      >
          <div
              className={`toast ${type} ${fade ? "fade-in" : "fade-out"} ${
                  options.classNames || ""
              }`}
          >
              {type === "error" && <div className="error-icon"></div>}
              {type === "infoYellow" && (
                  <div className="info-yellow-icon"></div>
              )}
              {type === "success" && <div className="sucess-green-icon"></div>}
              {iconSrc !== "" && (
                  <div
                      style={{
                          width: "20px",
                          height: "20px",
                          marginRight: "5px",
                      }}
                  >
                      <img
                          style={{ width: "100%", height: "100%" }}
                          src={iconSrc}
                          alt="icon"
                      />
                  </div>
              )}
              <div className={`toastMessage ${options?.messageClass}`}>
                  {message}
              </div>
              {/* <button onClick={onClose}>X</button> */}
          </div>
      </div>
  );
};

export default CustomizedToast;